export default __webpack_public_path__ + "static/feature-pay-to-download-a02a6b044f07e870f5ba8f2a5c91058c.webp";